import { render, staticRenderFns } from "./Mirror.vue?vue&type=template&id=de578a3e&"
import script from "./Mirror.vue?vue&type=script&lang=js&"
export * from "./Mirror.vue?vue&type=script&lang=js&"
import style0 from "./Mirror.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports